import { ApplicationSettings } from '@spa/generated/graphql/graphql';

const shouldLoadWishlists = ({
  cartEnabled,
  myAccountEnabled,
  pdpEnabled,
  plpEnabled
}: ApplicationSettings['wishlistSettings']): boolean =>
  cartEnabled || myAccountEnabled || pdpEnabled || plpEnabled;

export default shouldLoadWishlists;
